// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { GetShipTosApiParameter } from "@insite/client-framework/Services/CustomersService";
import { reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

export interface xRfqMyQuotesState {
    xRfqMyQuotes: {
        getShipTosParameter?: GetShipTosApiParameter;
    };
}

const initialState = {
    getShipTosParameter: {
        page: 1,
        pageSize: 20,
    },
};

const reducer = {
    "xRfqMyQuotes/UpdateShipTosSearchFields": (
        draft: Draft<{ getShipTosParameter?: GetShipTosApiParameter }>,
        action: { parameter: GetShipTosApiParameter },
    ) => {
        draft.getShipTosParameter = { ...draft.getShipTosParameter, ...action.parameter };
    },
};
const xRfqMyQuotes = createTypedReducerWithImmer(initialState, reducer);

(reducers as any).xRfqMyQuotes = xRfqMyQuotes;

export default createTypedReducerWithImmer(initialState, reducer);
